/* global $ */

export class HighlightsControl {
	constructor(el) {
		this.$highlights = $(el)
		if (!this.$highlights) return

		// props for video
		this.activeVideo = null
		this.lastTime = -1

		// bind this to methods
		this.scrollHandler = this.scrollHandler.bind(this)
		this.videoBeat = this.videoBeat.bind(this)

		this.$contentContainer = this.$highlights.find('.highlight-content-container')
		this.$contentNav = this.$highlights.find('.highlight-list .highlight-button a')
		this.$contentSets = this.$highlights.find('.highlight-content')

		// if there is only one nav button, hide it
		if (this.$highlights.find('.highlight-button').length === 1) {
			this.$highlights.find('.highlight-list').addClass('hide')
		}

		// clicking a nav button opens up that content set
		this.$contentNav.each((index, el) => {
			$(el).on('click', (e) => {
				e.preventDefault()
				this.setActiveContent(index)

				$('html, body').scrollTop(this.$contentContainer.offset().top - $(window).outerHeight() * 0.5)
			})
		})

		// set first highlight as active by default
		this.setActiveContent(0)
	}

	setSlide($slide) {
		const $content = $slide.closest('.highlight-content')

		// update image only if slide is not already active
		if (!$slide.hasClass('active')) {
			$slide.addClass('active').siblings('.slide').removeClass('active')
			// update image
			if ($slide.data('image') !== undefined) {
				const $img = $content.find('.media img')
				$img.attr('src', $slide.data('image'))
			}

			// clear old dots
			$content.find('.media .dot').remove()

			// create dots
			if ($slide.data('dot') !== undefined) {
				const coords = $slide.data('dot').split(',')
				for (let i = 0; i < coords.length; i += 2) {
					const $dot = $('<div class="dot"></div>')
					$dot.css({ left: coords[i] + '%', top: coords[i + 1] + '%' })
					$content.find('.image-box').append($dot)
				}
			}
		}
	}

	setInitialSlide() {
		this.setSlide($('.highlight-content .slide:visible').first())
	}

	setActiveContent(index) {
		// set nav button state
		this.$contentNav.each((id, el) => {
			$(el)
				.closest('li')
				.toggleClass('active', id === index)
		})

		let $activeSet
		// set content state
		this.$contentSets.each((id, el) => {
			$(el).toggleClass('active', id === index)
			if (id === index) {
				$activeSet = $(el)
			}
		})

		// set initial slide
		this.setInitialSlide()

		// cancel previous scroll event
		$(window).off('scroll', this.scrollHandler)

		// cancel video animation timer
		window.cancelAnimationFrame(this.videoBeat)
		this.activeVideo = null

		if ($activeSet.find('.image-box').length) {
			// we are using images and hotspots

			// if video exists, hide it
			$activeSet.find('.image-box').siblings().hide()

			this.setInitialSlide()

			// scroll-triggered image changes
			$(window).on('scroll', this.scrollHandler)
		} else if ($activeSet.find('.video').length) {
			// we are using a video

			this.activeVideo = $activeSet.find('.video video')[0]

			// set up videos to start paused on first frame
			$activeSet.find('.video video').each((index, el) => {
				const video = $(el)
				video[0].pause()

				video.on('loadedmetadata', function () {
					video[0].pause()
				})
			})

			window.requestAnimationFrame(this.videoBeat)
		}
	}

	scrollHandler() {
		const st = $(window).scrollTop()
		const wh = $(window).outerHeight()

		// check if entire image is in view
		// const imageLarge = st >= this.$contentContainer.offset().top - wh * 0.5
		// $('.highlights').toggleClass('large-image', imageLarge)

		// check which slide is in view
		$('.highlight-content .slide:visible').each((index, el) => {
			const t = $(el).offset().top

			// center of view bounds
			const min = t - wh * 0.5
			const max = t

			// if slide is in center of view
			if (st >= min && st < max) {
				this.setSlide($(el))
				return false
			}
		})
	}

	videoBeat() {
		if (this.activeVideo === null) return

		this.updateVideo()
		window.requestAnimationFrame(this.videoBeat)
	}

	updateVideo() {
		const st = $(window).scrollTop()
		const wh = $(window).outerHeight()

		// console.log(wh);
		const top = this.$contentContainer.offset().top + (wh * .25)
		const bottom = this.$contentContainer.outerHeight() + top - (wh * 1.25)

		// console.log(top, bottom, st);
		// const offset = wh / 2

		let percent = 1 - (bottom - st) / (bottom - top)

		// console.log(percent);
		percent = Math.min(Math.max(percent, 0), 1)

		// console.log(percent);

		const currTime = percent * this.activeVideo.duration

		if (isNaN(currTime)) {
			return
		}

		// only update video time if the time has changed
		if (this.lastTime !== currTime) {
			this.activeVideo.currentTime = currTime
			this.lastTime = currTime
		}
	}
}
